import { useCallback } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';

const useBookmarkTooltip = () => {
  const [open, openMethods] = useToggle(false);
  const [disabled, disabledMethods] = useToggle(false);

  const onClose = useCallback(() => {
    openMethods.off();
    disabledMethods.off();
  }, [disabledMethods, openMethods]);

  return {
    open: !disabled && open,
    onClose,
    onOpen: openMethods.on,
    onDisable: disabledMethods.on,
  };
};

export default useBookmarkTooltip;
